import React, { useEffect, useState } from 'react';
import {
  Box, SimpleGrid, Stat, StatLabel, StatNumber, Text, Flex, Card, CardBody, Spinner,
} from '@chakra-ui/react';
import {
  PieChart, Pie, Cell, Tooltip, ResponsiveContainer, Legend,
} from 'recharts';
import axios from 'axios';

const DashboardRegistroContratistas = () => {
  const [data, setData] = useState<any[]>([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    axios.get(`${process.env.REACT_APP_API_URL || "http://127.0.0.1:5000"}/api/obras/registro-contratista`)
      .then(res => setData(res.data))
      .catch(() => setData([]))
      .finally(() => setLoading(false));
  }, []);

  if (loading) return <Spinner size="xl" color="blue.500" />;

  const total = data.length;

  const especialidades = data.reduce((acc: any, item) => {
    const key = item.especialidades || 'No especificada';
    acc[key] = (acc[key] || 0) + 1;
    return acc;
  }, {});

  const chartData = Object.entries(especialidades).map(([name, value]) => ({ name, value }));
  const promedioExperiencia = Math.round(data.reduce((acc, curr) => acc + (curr.experiencia || 0), 0) / (total || 1));

  const colors = ['#805AD5', '#38A169', '#DD6B20', '#319795', '#E53E3E'];

  return (
    <Box p={6}>
      <Flex justify="center" mb={6}>
   

        <Card flexBasis={{ base: '100%', md: '400px' }} boxShadow="none">
          <CardBody>
            <Text fontWeight="bold" mb={4} textAlign="center">
              Distribución por Especialidad
            </Text>
            <ResponsiveContainer width="100%" height={250}>
              <PieChart>
                <Pie
                  data={chartData}
                  dataKey="value"
                  nameKey="name"
                  cx="50%"
                  cy="50%"
                  outerRadius={80}
                  label
                >
                  {chartData.map((entry, index) => (
                    <Cell key={index} fill={colors[index % colors.length]} />
                  ))}
                </Pie>
                <Tooltip />
                <Legend />
              </PieChart>
            </ResponsiveContainer>
          </CardBody>
        </Card>
      </Flex>
      <SimpleGrid columns={{ base: 2, md: 3 }} spacing={4} flex={1}>
          <Stat p={4} bg="white" borderRadius="md" boxShadow="md">
            <StatLabel>Contratistas Registrados</StatLabel>
            <StatNumber>{total}</StatNumber>
          </Stat>
          <Stat p={4} bg="white" borderRadius="md" boxShadow="md">
            <StatLabel>Promedio de Experiencia</StatLabel>
            <StatNumber>{promedioExperiencia} años</StatNumber>
          </Stat>
          <Stat p={4} bg="white" borderRadius="md" boxShadow="md">
            <StatLabel>Especialidades Únicas</StatLabel>
            <StatNumber>{Object.keys(especialidades).length}</StatNumber>
          </Stat>
        </SimpleGrid>
    </Box>
  );
};

export default DashboardRegistroContratistas;
